/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { BasicText, asField } from 'informed';

// eslint-disable-next-line no-unused-vars
const validate = value => (!value || value === 0 ? 'Field must be at least five characters' : undefined);

const NumberField = ({ fieldState, ...props }) => {
  const { disabled, id, label } = props;
  const { value } = fieldState;

  const handleChange = e => {
    const { fieldApi, onChange } = props;
    const valueNumber = Number(e.target.value);
    if (fieldApi.setValue) fieldApi.setValue(valueNumber);

    if (onChange) {
      onChange(valueNumber);
    }
  };

  return (
    <>
      <label htmlFor={id}>
        {label}
        <BasicText
          type="number"
          onChange={handleChange}
          fieldState={fieldState}
          value={!value && value !== 0 ? '' : Number(value)}
          {...props} // eslint-disable-line react/jsx-props-no-spreading
          style={fieldState.error ? { border: 'solid 1px red' } : null}
          disabled={disabled}
        />
        {fieldState.error ? <small style={{ color: 'red' }}>{fieldState.error}</small> : null}
      </label>
    </>
  );
};

NumberField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

NumberField.defaultProps = {
  label: undefined,
  disabled: false,
  onChange: undefined,
};

export default asField(NumberField);
